import { authHeader } from '../util/authHeader'
import store from '../store/'
import appLocalStorage from '../util/appLocalStorage'

let baseUrl = process.env.VUE_APP_API_BASE_URL

export const repairOptionsService = {
  // getSelectedByGadgetWebReference,
  getByGadgetWebReference,
  setRepairOptionForGadget,
  attemptExcessPaymentForGadget,
  setBookingDateAndChargeForGadget,
  CancelBooking,
  getSelectedStatusHistory,
  setUserNotificationAccount
}

function setUserNotificationAccount (id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  }
  // eslint-disable-next-line no-undef
  return fetch(baseUrl + '/api/v1/repairoptions/setusernotificationaccount/' + id, requestOptions)
    .then(response => {
      return response.text().then(text => {
        const data = text && JSON.parse(text)
        if (!response.ok) {
          if (response.status === 401) {
          // auto logout if 401 response returned from api
            appLocalStorage.clearStore()
            store.dispatch('authentication/logout')
            store.dispatch('myclaims/reset')
            store.dispatch('claimform/reset')
            store.dispatch('repairoptions/reset')
          
            window.location.reload(true)
          }

          const error = (data && data.message) || response.statusText
          return Promise.reject(error)
        }

        return Promise.resolve(data)
      })
    })

}

function getSelectedStatusHistory (id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  }

  // eslint-disable-next-line no-undef
  return fetch(baseUrl + '/api/v1/repairoptions/selectedstatushistory/' + id, requestOptions)
    .then(response => {
      return response.text().then(text => {
        const data = text && JSON.parse(text)
        if (!response.ok) {
          if (response.status === 401) {
          // auto logout if 401 response returned from api
            appLocalStorage.clearStore()
            store.dispatch('authentication/logout')
            store.dispatch('myclaims/reset')
            store.dispatch('claimform/reset')
            store.dispatch('repairoptions/reset')
          
            window.location.reload(true)
          }

          const error = (data && data.message) || response.statusText
          return Promise.reject(error)
        }

        return Promise.resolve(data)
      })
    })
}

function getByGadgetWebReference (webReference) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(baseUrl + `/api/v1/repairoptions/optionsforgadget/` + webReference, requestOptions).then(handleResponse)
}

function setRepairOptionForGadget (payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(payload)
  }

  return fetch(baseUrl + '/api/v1/repairoptions/', requestOptions).then(handleResponseEx)
}

function attemptExcessPaymentForGadget (payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(payload)
  }

  return fetch(baseUrl + '/api/v1/payment/', requestOptions).then(handleResponseEx)
}

function setBookingDateAndChargeForGadget (payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(payload)
  }

  return fetch(baseUrl + '/api/v1/booking/setdate/', requestOptions).then(handleResponseEx)
}

function CancelBooking (payload) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  }

  return fetch(baseUrl + '/api/v1/booking/order/' + payload + '/cancel', requestOptions).then(handleResponseEx)
}

function handleResponseEx (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout()
        location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return Promise.resolve(data)
  })
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout()
        location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}

// static fetchRepairOptions(otcode) {
//       return axios.get( baseUrl + '/api/v1/repairoptions/' + otcode);
//     }
